export default class Salary {
    constructor(opts) {
        // consts
        this.WEEKS_IN_YEAR = 52;
        this.MONTHS_IN_YEAR = 12;
        this.FREQ_HOUR = 'hour';
        this.FREQ_DAY = 'day';
        this.FREQ_WEEK = 'week';
        this.FREQ_MONTH = 'month';
        this.FREQ_YEAR = 'year';

        // defaults
        this.annualAllowances = 0;
        this.annualBonus = 0;
        this.annualExpense = 0;

        this.salary = opts.salary;
        this.employee = opts.employee;
        this.frequency = opts.frequency;

        if ('annualAllowances' in opts) {
            this.annualAllowances = opts.annualAllowances;
        }

        if ('annualBonus' in opts) {
            this.annualBonus = opts.annualBonus;
        }

        if ('annualExpense' in opts) {
            this.annualExpense = opts.annualExpense;
        }
    }

    getBase(toFrequency) {
        return this.convert(this.salary, this.frequency, toFrequency);
    }

    getGross(toFrequency) {
        const annualIncome = this.annualBonus + this.annualAllowances + this.convert(
            this.salary,
            this.frequency,
            this.FREQ_YEAR
        );

        return this.convert(annualIncome, this.FREQ_YEAR, toFrequency);
    }

    convert(income, fromFrequency, toFrequency) {
        const annualIncome = this.convertToAnnual(income, fromFrequency);
        return this.convertFromAnnual(annualIncome, toFrequency);
    }

    convertToAnnual(income, fromFrequency) {
        const hoursPerDay = this.employee.hoursPerDay;
        const daysPerWeek = this.employee.daysPerWeek;

        if (fromFrequency === this.FREQ_HOUR) {
            return income * this.WEEKS_IN_YEAR * daysPerWeek * hoursPerDay;
        }

        if (fromFrequency === this.FREQ_DAY) {
            return income * this.WEEKS_IN_YEAR * daysPerWeek;
        }

        if (fromFrequency === this.FREQ_WEEK) {
            return income * this.WEEKS_IN_YEAR;
        }

        if (fromFrequency === this.FREQ_MONTH) {
            return income * this.MONTHS_IN_YEAR;
        }

        return income;
    }

    convertFromAnnual(income, toFrequency) {
        const hoursPerDay = this.employee.hoursPerDay;
        const daysPerWeek = this.employee.daysPerWeek;

        if (toFrequency === this.FREQ_HOUR) {
            return income / this.WEEKS_IN_YEAR / daysPerWeek / hoursPerDay;
        }

        if (toFrequency === this.FREQ_DAY) {
            return income / this.WEEKS_IN_YEAR / daysPerWeek;
        }

        if (toFrequency === this.FREQ_WEEK) {
            return income / this.WEEKS_IN_YEAR;
        }

        if (toFrequency === this.FREQ_MONTH) {
            return income / this.MONTHS_IN_YEAR;
        }

        return income;
    }
}